import React from 'react';
import { Link } from 'gatsby';
import { MapPin } from 'lucide-react';

export const regions = [
  { name: "Toronto", description: "Canada's largest city with diverse security opportunities" },
  { name: "Ottawa", description: "Capital city with government and institutional security" },
  { name: "Mississauga", description: "Major aviation and logistics security hub with Canada's largest airport" },
  { name: "Hamilton", description: "Industrial city with manufacturing security focus" },
  { name: "London", description: "Education and healthcare security hub" },
  { name: "Windsor", description: "Border city with international trade security" },
  { name: "Waterloo", description: "Tech sector and educational security" },
  { name: "Sudbury", description: "Northern Ontario's mining security center" },
  { name: "Thunder Bay", description: "Northwestern Ontario's port security" },
  { name: "Kingston", description: "Historic city with institutional security" },
  { name: "Guelph", description: "Research and biotech security focus" },
  { name: "Durham", description: "Fast-growing region with diverse security" },
  { name: "Halton", description: "Upscale retail and residential security" },
  { name: "Niagara", description: "Tourism and casino security focus" },
  { name: "Peel", description: "Airport and logistics security hub" },
  { name: "York", description: "Tech and development security focus" }
];

interface RegionsListProps {
  className?: string;
  showDescriptions?: boolean;
  columns?: 1 | 2 | 3 | 4;
  compact?: boolean;
}

const RegionsList: React.FC<RegionsListProps> = ({ 
  className = "", 
  showDescriptions = true, 
  columns = 4,
  compact = false
}) => {
  const gridCols = {
    1: "grid-cols-1",
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-4 ${className}`}>
      {regions.map((region) => (
        <Link
          key={region.name}
          to={`/ontario/${region.name.toLowerCase().replace(' ', '-')}`}
          className={`block bg-white rounded-lg ${compact ? 'p-3' : 'p-6'} shadow-md hover:shadow-lg transition-shadow border border-gray-100`}
          title={`CRJMC in ${region.name} - ${region.description}`}
        >
          <div className="flex items-center mb-3">
            <MapPin className="w-5 h-5 text-primary mr-2" />
            <h3 className={`${compact ? 'text-base' : 'text-lg'} font-semibold`}>{region.name}</h3>
          </div>
          {showDescriptions && (
            <p className="text-sm text-gray-600">{region.description}</p>
          )}
        </Link>
      ))}
    </div>
  );
};

export default RegionsList; 